<template>
  <div>
    <p class="header">Learn in this 1-minute video how your brain might have fooled you. Then go to the results below to see if it managed to do so.</p>
    <youtube class="margins" player-width="800" player-height="450" video-id="uQHRc6ZGqcY"></youtube>
    <bg-button class="button" @click="$router.push({ name: 'stepseven' })" text="See the results"></bg-button>
  </div>
</template>

<style scoped>
.margins {
  transform: translateX(-50%);
  position: absolute;
  left: 50%;
}
.button {
  margin-top: 500px;
}
.input {
  width: 140px;
  margin: auto;
}
.header {
  margin-bottom: 40px;
  font-size: 18px;
}
.paragraph {
  margin-bottom: 10px;
}
.image-holder {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.image {
  width: auto;
  margin: 5px;
  max-width: initial;
}
.small-image-holder {
  display: flex;
  flex-direction: column;
}
</style>

<script>
import BgButton from "../components/bg-button";
export default {
  name: "App",
  components: {
    BgButton
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    price() {
      return this.$store.state.price;
    }
  }
};
</script>
